
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { formatDate, formatThousands } from '@/utils'
import { getSlipBufferDetail } from '@/apis/paymentSlip/paymentSlip'
import { PaymentSlipBufferDetailModel } from '@/model/paymentSlip/paymentSlipModel'
import Container from '@/components/form/container/Container.vue'

export default defineComponent({
  name: 'PaymentSlipBufferDetail',
  methods: { formatThousands },
  props: {
    inputData: {
      type: Object,
      required: true,
      default: null
    },
    labelWidth: {
      type: String,
      default: '680px'
    }
  },
  components: {
    Container
  },
  setup() {
    const { t } = useI18n()
    const id = useRoute().params.id.toString()
    const dataMap = reactive({
      detailData: {} as PaymentSlipBufferDetailModel | null,
      paymentDate: '',
      listLoading: true,
      async getData() {
        dataMap.listLoading = true
        const data = await getSlipBufferDetail(id)
        if (data && data.data) {
          dataMap.detailData = data.data
        }
        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      paymentDateFormat(paymentDate: Date): string {
        return formatDate(paymentDate, 'yyyy-MM-dd')
      }
    })
    onMounted(() => {
      dataMap.getData()
    })
    return {
      t,
      ...toRefs(dataMap)
    }
  }
})
